window.initLogoHover = function initLogoHover() {
  const logos = document.querySelectorAll('.logo');

  logos.forEach((logo) => {
    if (logo.querySelector('.logo-animation')) {
      logo.classList.add('is-animate-done');
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLogoHover);
} else {
  initLogoHover();
}
